var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "g-searchspring__listing g-product-list" }, [
    _vm.pagination.totalResults > 0
      ? _c(
          "div",
          { staticClass: "g-layout u-grids-2 u-grids-3--m u-grids-4--l" },
          [
            _vm._l(_vm.results, function (result, index) {
              return [
                result.isInlineBanner
                  ? _c("inline-banner", {
                      key: index,
                      attrs: { result: result },
                    })
                  : _c("product-card", {
                      key: index,
                      attrs: { result: result },
                    }),
              ]
            }),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.pagination.totalResults === 0
      ? _c("div", { staticClass: "g-search-results-empty" }, [
          _c("div", { staticClass: "g-search-results-empty__message" }, [
            _vm._v("\n\t\t\tNo products matched your search criteria.\n\t\t"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "g-search-results-empty__suggestion" }, [
            _vm.didYouMean.query
              ? _c(
                  "div",
                  { staticClass: "g-search-results-empty__suggestion-content" },
                  [
                    _vm._v("\n\t\t\t\tDid you mean "),
                    _c(
                      "a",
                      {
                        staticClass: "g-search-results-empty__suggestion-link",
                        attrs: {
                          href: `/search-results.html?Search=${_vm.didYouMean.query}`,
                          title: _vm.didYouMean.query,
                        },
                      },
                      [_vm._v(_vm._s(_vm.didYouMean.query))]
                    ),
                    _vm._v("?\n\t\t\t"),
                  ]
                )
              : _c(
                  "div",
                  { staticClass: "g-search-results-empty__suggestion-content" },
                  [
                    _vm._v("\n\t\t\t\tTry a different search or go back to "),
                    _c(
                      "a",
                      {
                        staticClass: "g-search-results-empty__suggestion-link",
                        attrs: { href: "/", title: "Back to home" },
                      },
                      [_vm._v("Home")]
                    ),
                    _vm._v(".\n\t\t\t"),
                  ]
                ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }